export default __webpack_public_path__ + "static/media/sms.ea2cba5c.svg";